import * as React from 'react';

import { cn } from '@/lib/utils';

function Card({ className, variant = 'default', interactive = false, ...props }: React.ComponentProps<'div'> & { variant?: 'default' | 'glass', interactive?: boolean }) {
  return (
    <div
      data-slot="card"
      data-variant={variant}
      className={cn(
        'rounded-lg border transition-all duration-200 flex flex-col',
        'bg-card text-card-foreground border-border shadow-sm',
        interactive && 'hover:shadow-md hover:border-primary/20 hover:-translate-y-0.5 cursor-pointer active:scale-[0.99]',
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-header"
      // gap, not space-y: callers lay the header out as a row (title + action)
      // and space-y's top margin pushed the action off the title's baseline.
      className={cn('flex flex-col gap-1 p-5 pb-3', className)}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'h3'>) {
  return (
    <h3
      data-slot="card-title"
      className={cn(
        'text-base font-semibold tracking-tight text-foreground',
        className,
      )}
      {...props}
    />
  );
}


function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-description"
      className={cn('text-sm text-muted-foreground', className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className,
      )}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-content"
      className={cn('p-5 pt-0', className)}
      {...props}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center p-5 pt-0', className)}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
